<template>
  <nav
    v-if="breadcrumbsList && breadcrumbsList.length"
    :class="[$style.breadcrumbs, { [$style.breadcrumbsScrollX]: isWithXScroll }]"
  >
    <ul :class="$style.breadcrumbsList">
      <li
        v-for="(item, index) in breadcrumbsList"
        :key="item.id || Math.random()"
        :class="$style.breadcrumbsItem"
        @click="scrollTop"
      >
        <NuxtLink
          v-if="item.itemLink"
          :to="`${langPrefix}${langPrefix && item.itemLink === '/' ? '' : item.itemLink}`"
          :title="item.itemTitle"
        >
          <img
            v-if="item.itemImage && item.itemImage.url"
            :class="$style.breadcrumbsImg"
            :src="item.itemImage.url"
            alt="breadcrumbsImg"
          />
          <span v-else>{{ item.itemTitle }}</span>
        </NuxtLink>
        <span v-else>{{ item.itemTitle }}</span>
        <BreadcrumbsArrow
          v-if="index + 1 !== breadcrumbsList.length"
          :class="$style.breadcrumbsArrow"
        />
      </li>
    </ul>
    <!-- <script type="application/ld+json" v-html="JSON_LD" /> -->
  </nav>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';
import BreadcrumbsArrow from '~/public/images/common/ico_slider_arrow_right.svg?component';
import { useStoreRoot } from '~/stores/abstract/root';
import type { IBreadcrumbs } from '~/types/breadcrumbs';

// interface ListItemInterface {
//   '@type': 'ListItem';
//   position: number;
//   name: string;
//   item?: string;
// }

defineProps({
  breadcrumbsList: {
    type: Array as PropType<IBreadcrumbs[]>,
    required: true,
  },
  isWithXScroll: {
    type: Boolean,
    default: false,
  },
});

const storeRoot = useStoreRoot();

const origin = ref('https://7bitcasino.com');

const langPrefix = computed(() => (storeRoot.domainLang ? `/${storeRoot.domainLang}` : ''));

// const JSON_LD = computed(() => {
//   const itemListElement: ListItemInterface[] = [];

//   props.breadcrumbsList.forEach((item, index) => {
//     const listItem: ListItemInterface = {
//       '@type': 'ListItem',
//       position: index + 1,
//       name: item.itemTitle || '',
//     };

//     if (item.itemLink) {
//       listItem.item = `${origin.value}${langPrefix.value}${
//         langPrefix.value && item.itemLink === '/' ? '' : item.itemLink
//       }`;
//     }

//     itemListElement.push(listItem);
//   });

//   return JSON.stringify({
//     '@context': 'https://schema.org',
//     '@type': 'BreadcrumbList',
//     itemListElement,
//   });
// });

const scrollTop = () => {
  if (import.meta.browser && window) {
    window.scrollTo(0, 0);
  }
};

onMounted(() => (origin.value = location.origin));
</script>

<style lang="scss" module src="./breadcrumbs.scss"></style>
